import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-12a8e88d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "underline-container" }
const _hoisted_2 = {
  key: 0,
  class: "error-text"
}

import { ref, watch } from "vue";

interface Props {
  modelValue?: string | number;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputUnderLine',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: false },
    error: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const innerValue = ref(String(props.modelValue ?? ""));
const isFocused = ref(false);

watch(
  () => props.modelValue,
  (val) => {
    innerValue.value = String(val ?? "");
  }
);

const handleInput = (e: Event) => {
  const target = e.target as HTMLInputElement;

  innerValue.value = target.value;

  emits("update:modelValue", target.value);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_input, {
        value: innerValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        status: _ctx.error ? 'error' : '',
        class: "underline-input",
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (isFocused.value = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (isFocused.value = false)),
        onInput: handleInput
      }, null, 8, ["value", "placeholder", "disabled", "status"]),
      _createElementVNode("div", {
        class: _normalizeClass(["underline", {
        active: isFocused.value || innerValue.value,
        error: _ctx.error,
      }])
      }, null, 2)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})